"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onSubmit = (update, contentFeed) => (values) => {
    var _a, _b, _c;
    update({
        variables: {
            data: {
                cacheLength: values.cacheLength,
                contentMappingId: (_a = values.contentMapping) === null || _a === void 0 ? void 0 : _a.id,
                contentPushIndividualContentItems: values.contentPushIndividualContentItems === true,
                contentPushIsEnabled: values.contentPushIsEnabled === true,
                headers: values.headers,
                name: values.name,
                responseType: (_b = values.responseType) === null || _b === void 0 ? void 0 : _b.value,
                url: values.url,
                useHeadersFromContentFeedId: (_c = values.useHeadersFromContentFeed) === null || _c === void 0 ? void 0 : _c.id,
            },
            id: contentFeed.id,
        },
    });
};
//# sourceMappingURL=onSubmit.js.map